import { Box, Button, Link, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { usePageTitle } from "../common/TitleContext";
import { configService } from "../services/configService";
{
  // TODO: we will remove this page when we integrate with Taxbandits
}

type EmailSentLocationState = {
  userEmail?: string;
};

const EmailSentPage = () => {
  const { t } = useTranslation();

  usePageTitle("Email Validation");

  const location = useLocation();
  const navigate = useNavigate();

  const senderEmail = configService.config.senderEmail;
  const state = (location.state as EmailSentLocationState | null) ?? {};
  const userEmail = state.userEmail ?? "";

  const handleUpdateEmail = () => {
    // Navigate back to update email page
    navigate(-1);
  };

  return (
    <Box sx={{ maxWidth: 500, mx: "auto", textAlign: "center", p: 2, backgroundColor: "white", borderRadius: 0.5 }}>
      <Typography fontSize={24} fontWeight={600} gutterBottom>
        {t("tax_validateYourEmail_header")}
      </Typography>
      <Typography variant="body1" dangerouslySetInnerHTML={{ __html: t("tax_onboarding_checkEmail_description_p1", {
        "0": `<b>${senderEmail}</b>`,
        "1": `<b>${userEmail}</b>`,
      }) }} gutterBottom>
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t("tax_onboarding_checkEmail_description_p2")}
      </Typography>

      {/* <Typography variant="body1" sx={{ mt: 4 }}>
        {t("tax_validateYourEmail_didntReceiveEmail")}
      </Typography>
      <Link
        component="button"
        textAlign={"center"}
        variant="body2"
        onClick={handleUpdateEmail}
        sx={{ display: "block", mt: 2, margin: "auto" }}
      >
        {t("tax_validateYourEmail_incorrectEmail")}
      </Link> */}
    </Box>
  );
};

export default EmailSentPage;
